// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"input_wrapper__tl9Ta","errored":"input_errored__UNv5F","error":"input_error__nxsUy","label":"input_label__7AfhW"};